export const TRANSLATION_DEFAULT_LANGUAGE_CODE = "en";

export const TRANSLATION_DEFAULT_ERROR_MESSAGE =
  "Unfortunately, we've run into a problem trying to generate this. Please try again later.";
